import { ActionHandler, ActionHandlerParams } from "..";
import { saveAnswers } from "./saveAnswers";
import { trackLead } from "src/utils/services/ConversionTracker";
import { trackGotEmail } from "src/utils/api/tracker";
import saveToBraze, { flushCRMQueue } from "src/utils/brazeUploader";
import { isMHMDAState } from "src/utils/userSegment/features";
import { SessionStorageKey } from "src/utils/constants";
import { getNoomSessionStorage } from "src/utils/noomSessionStorage";
import { getEligibleMedProducts } from "src/utils/medEligibility";
import { getURLParams } from "src/utils/urlParams";

type Params = {
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompleteHealthSurvey: ActionHandler = async (
  actionParams: {
    params: Params;
  } & ActionHandlerParams
): Promise<void> => {
  const surveyAnswers = await saveAnswers(actionParams);

  if (isMHMDAState()) {
    const mhmdaAnswer = getNoomSessionStorage(SessionStorageKey.mhmdaAnswer);
    if (mhmdaAnswer === true || mhmdaAnswer === false) {
      await saveToBraze({ user: { mhmdaOptIn: mhmdaAnswer } });
    }
  }

  await flushCRMQueue();

  // Send the user chosen first name to Braze as well for some extra DRIP customization
  const { firstName, goal, mostImportantGoal, bodyCompositionGoal } =
    surveyAnswers;

  await saveToBraze({
    user: {
      ...(firstName && { first_name: firstName }),
      eligible_med_products: getEligibleMedProducts(),
      // Send health survey goal data to Iterable
      ...(goal && { healthCheckGoal: goal }),
      ...(mostImportantGoal && { mostImportantGoal }),
      ...(bodyCompositionGoal && { bodyCompositionGoal }),
    },
    event: {
      event_name: "HealthCheckOptInResponse",
      event_data: {
        optedIn: true,
        feature: getURLParams()?.feature,
      },
    },
  });

  const email = surveyAnswers.email || "";
  trackLead(email);
  if (email) {
    trackGotEmail(email);
  }
};
